
import useAuthStore from "../../store/useAuthStore";
import { getCookie } from "./CookieUtils";

export const bootstrapAuth = () => {
  const user = getCookie("user");
  const token = getCookie("accessToken");
  const refreshToken = getCookie("refreshToken");

  if (user && token) {
    useAuthStore.getState().login(user, token, refreshToken);
  }
};
